import { useQuery } from '@tanstack/react-query';
import { kpiApi } from '../lib/api.js';
import { queryKeys } from '../lib/query-keys.js';
import type { KpiPointProgressParams } from '../types/api.js';

/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business pt進捗比較データをTanStack Query経由で取得。team + 期間（月/FY四半期）指定で
 *  チーム/メンバー別の進捗目標pt・進捗実績pt（当月は営業日按分 + 処理中pt加算）を返す
 * @graph-connects /kpi/point-progress [calls] pt進捗比較API呼び出し
 * @graph-connects kpiApi.getPointProgress [calls] pt進捗比較APIクライアント呼び出し
 * @graph-connects queryKeys [calls] TanStack Queryキー生成
 */
export function useKpiPointProgress(params?: KpiPointProgressParams) {
  return useQuery({
    queryKey: queryKeys.kpi.pointProgress(params),
    queryFn: () => kpiApi.getPointProgress(params),
  });
}
